(function($){

    $(document).ready(function(){
        // Cache frequently used selectors
        const $window = $(window);
        const $document = $(document);
        const $body = $('body');
        const $header = $('header');

        // table of contents
        var $aWithId = $('h2, h3, h4');
        if ($aWithId.length > 0) {
            $('.js-table-of-contents').prepend('<div class="table-of-content"><div class="table-of-content-title">Table of Contents</div><ul></ul></div>');

            $('.blog-article-content').find($aWithId).each(function(i) {
                const elementId = i;
                let elementType;

                if ($(this).is('h2')) {
                    elementType = 'h2';
                } else if ($(this).is('h3')) {
                    elementType = 'h3';
                } else if ($(this).is('h4')) {
                    elementType = 'h4';
                }
                
                $(this).attr('id', 'title-'+elementId);

                var li = $('<li/>', {
                    class: elementType
                });
                var a = $('<a/>', {
                    text: $(this).text(),
                    href: '#title-' + elementId,
                    title: $(this).text()
                });
                a.appendTo(li);
                $('.js-table-of-contents ul').append(li);
            });
        }

        // ajax add comment
        $(document).on('click', '.js-close-comment-success', function() {
            $(this).closest('.comment-respond-success').remove();
            return false
        });

        $.extend($.fn, {
            validate: function () {
                $(this).parent().find('.error-label').remove();

                if ($(this).val().length < 3) {
                        $(this).addClass('error');
                        $(this).parent().append('<div class="error-label">Required field</div>');
                        return false
                    } else {
                        $(this).removeClass('error');
                        return true
                }
            },
            
validateEmail: function () {
                const emailToValidate = $(this).val();
                $(this).parent().find('.error-label').remove();

                if (!emailValidate(emailToValidate)) {
                    $(this).addClass('error');
                    $(this).parent().append('<div class="error-label">Email address is invalid</div>');
                    return false;
                } else if(emailToValidate === "") {
                    $(this).addClass('error');
                    $(this).parent().append('<div class="error-label">Required field</div>');
                    return false;
                } else {
                    $(this).removeClass('error');
                    return true;
                }
            },
        });
        
        $('#commentform').submit(function(){
            var button = $('#submit'),
                respond = $('#respond')
            
            if( $('#author').length )
                $('#author').validate();
            
            if( $('#email').length )
                $('#email').validateEmail();
            
            $('#comment').validate();
            
            if ( !button.hasClass('loadingform') && !$('#author').hasClass('error') && !$('#email').hasClass('error') && !$('#comment').hasClass('error') ){
                $.ajax({
                    type : 'POST',
                    url : '/wp-admin/admin-ajax.php',
                    data: $(this).serialize() + '&action=ajaxcomments',
                    beforeSend: function(xhr){
                        button.addClass('loadingform').text('Sending...');
                    },
                    error: function (request, status, error) {
                        if( status == 500 ){
                            alert( 'Error while adding comment');
                        } else if( status == 'timeout'){
                            alert('Error: Server doesn\'t respond.');
                        } else {
                            var wpErrorHtml = request.responseText.split("<p>"),
                                wpErrorStr = wpErrorHtml[1].split("</p>");
                                
                            alert( wpErrorStr[0] );
                        }
                    },
                    success: function ( addedCommentHTML ) {
                        respond.append('<div class="comment-respond-success"><a href="#" class="comment-respond-success-close js-close-comment-success"></a><div class="comment-respond-success-icon"></div><div class="comment-respond-success-text">Thank you for being part<br>of our community!</div></div>');
                        $('#author, #email, #comment').val('');
                    },
                    complete: function(){
                        
                        button.removeClass('loadingform').text('Send');
                    }
                });
            }
            return false;
        });

        // ajax comments pagination
        function getComments(button) {
            cpage++;
            
            button.removeClass('js-comment-loadmore');
    
            $.ajax({
                url : '/wp-admin/admin-ajax.php',
                data : {
                    'action': 'cloadmore',
                    'post_id': parent_post_id,
                    'cpage' : cpage,
                },
                type : 'POST',
                beforeSend : function ( xhr ) {
                    button.text('Loading...');
                },
                success : function( data ){
                    data = JSON.parse(data);
                    if( data ) {
                        $('.comment-list').append(data.items);
                        button.addClass('js-comment-loadmore');
                        button.text('See more');
                        if ( data.next_page < 1 )
                            button.remove();
                    } else {
                        button.remove();
                    }
                }
            });

            return false;
        }

        $('.js-comment-loadmore').click( function(){
            var button = $(this);

            getComments(button);
        });

        // open order modal
        $('.js-openOrderModal').click(function(){
            $('#orderModal').arcticmodal();
            $('.js-productNameOrderModal').val($(this).data('title'));
            $('.js-productHrefOrderModal').val($(this).data('link'));
        });

        // scroll to block
        if (window.location.hash) {
            setTimeout(function(){
                scrollToSection(window.location.hash);
            }, 50);
        }

        $('a[href*="#"]').click(function (e) {
          e.preventDefault();
          if (this.pathname === window.location.pathname) {
            scrollToSection(this.hash);
          }
          else {
            window.location.replace(this.href);
          }
        });

function scrollToSection(id) {
            const headerHeight = $header.outerHeight() + 28;
            if($window.innerWidth() < 768){
                $('html, body').animate({
                    scrollTop: $(id).offset().top - headerHeight
                }, 1000);
            } else {
                $('html, body').animate({
                    scrollTop: $(id).offset().top
                }, 1000);
            }
        }

// Unified email validation function
        function emailValidate(email) {
            const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return emailRegExp.test(email);
        }

        var isSended = true;
        function formValid(form) {
            if (isSended){
                isSended = false;
                let fields = form.find('*:required');
                let stars = form.find('.js-validStars');

                let valid = true;
                fields.each(function() {
                    let field = $(this);
                    let fieldVal = field.val();
                    let fieldProp = field.prop('checked');

                    field.removeClass('invalid');                
                    if (!fieldVal || fieldVal == null || fieldVal == '') {
                        field.addClass('invalid');
                        valid = false;
                    }
                    else if (field.attr('name') == 'email' && !emailValidate(fieldVal)) {
                        field.addClass('invalid');
                        valid = false;
                    }
                    else if (field.attr('type') == 'checkbox') {
                        field.parent().removeClass('invalid');
                        if (field.prop('checked') == false) {
                            field.parent().addClass('invalid');
                            valid = false;
                        }                    
                    }
                    
                });
                if ($('.invalid').length) {
                    $('html, body').animate({scrollTop: $('.invalid').offset().top-125}, 800);
                }
                isSended = true;
                return valid;
            }
        }

        // modal video
        if ($('.js-video-button').length > 0) {
            $('.js-video-button').modalVideo();
        }

        // disable link
        $('.js-link-false').click(function(){
            return false
        });


        // burger menu
        $('.js-burger').click(function(){
            $('.js-burgerMenu').show();
            $('.js-burgerMenu').addClass('mobile');
        });
        $('.js-burgerClose').click(function(){
            $('.js-burgerMenu').hide();
            $('.js-burgerMenu').removeClass('mobile');
        });

function mobileHeader() {
            const headerHeight = $header.outerHeight() + 28;

            if($window.innerWidth() < 768){
                $header.addClass('fixed');
                $body.css({
                    'paddingTop': headerHeight + 'px'
                });
            } else {
                $header.removeClass('fixed');
                $body.css({
                    'paddingTop': '0px'
                });
            }
        }

$window.on('load', function() {
            mobileHeader();
        });

        $window.resize(function() {
            if($window.innerWidth() < 768){
                $('.js-burgerMenu').hide();
                $('.js-burgerMenu').removeClass('mobile');
            } else {
                $('.js-burgerMenu').css('display', 'flex');
            }
            mobileHeader();
        });
        $('.js-burgerMenu a').click(function(){
            if($window.innerWidth() < 768){
                $('.js-burgerMenu').hide();
                $('.js-burgerMenu').removeClass('mobile');
            }
        });

        // dropdown menu
        $('.js-dropdownMenu>a').click(function(){
            $(this).parent().find('.menu-dropdown-container').toggle();
            $(this).parent().toggleClass('active');
            return false
        });
        $(document).mouseup( function(e){
            var div = $( ".js-dropdownMenu" );
            if ( !div.is(e.target)
                && div.has(e.target).length === 0 ) {
                div.find('.menu-dropdown-container').hide();
                div.removeClass('active');
            }
        });

        // niceSelect
        $('.js-niceSelect').niceSelect();

        // brands slider
        $('.js-slider-brands').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 7,
            slidesToScroll: 1,
            prevArrow: $('.js-slider-brands-arrowPrev'),
            nextArrow: $('.js-slider-brands-arrowNext'),
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        arrows: false,
                        dots: true
                    }
                },
            ]
        });

        // reviews slider
        $('.js-slider-reviews').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: $('.js-slider-reviews-arrowPrev'),
            nextArrow: $('.js-slider-reviews-arrowNext'),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                        dots: true
                    }
                },
            ]
        });

// Universal tabs function
        function initTabs(containerSelector, buttonSelector, buttonAttr, contentAttr, contentContext) {
            const $containers = $(containerSelector);
            if ($containers.length === 0) return;

            $containers.each(function() {
                const $container = $(this);
                const $buttons = $container.find(buttonSelector);
                const $contentContext = contentContext ? $container.closest(contentContext) : $container;
                const $contentItems = $contentContext.find('[data-' + contentAttr + ']');

                $buttons.on('click', function(e) {
                    e.preventDefault();
                    const $button = $(this);
                    
                    if (!$button.hasClass('active')) {
                        $buttons.removeClass('active');
                        $button.addClass('active');
                        
                        const tabId = $button.data(buttonAttr.replace('-', ''));
                        $contentItems.addClass('hidden');
                        $contentContext.find('[data-' + contentAttr + '="' + tabId + '"]').removeClass('hidden');
                    }
                });
            });
        }

        // Initialize all tabs
        initTabs('.js-planTabs', '.js-planTabsBtn', 'plan-tabs', 'plan-tabs');
        initTabs('.js-tabs', '.js-tabs-btn', 'target', 'tabs');

        // tabs select
        $(document).on('change', '.js-TabsSelect', function(event) {
            let tabs = $('.js-tabs');
            let tabsContent = $('[data-tabs]');
            let tabSelectVal = $(this).find('option:selected').attr('data-select-target');;
            tabsContent.addClass('hidden');
            tabsContent.addClass('hidden');
            $('[data-tabs="'+tabSelectVal+'"]').removeClass('hidden');
        });

        // subscribe form
        $('.js-form-subscribe').on('submit', function() {
            let form = $(this);
            let submBtn = form.find('[type="submit"]');
            submBtn.addClass('disabled');
            $('.subscribeform-form-alert-line').hide();
            if (formValid(form)) {
                form.find('input').val('');
                $('.subscribeform-form-alert-line.success').css('display', 'flex');
            }
            else {
                $('.subscribeform-form-alert-line.error').css('display', 'flex');
                submBtn.removeClass('disabled');
            }
            return false;
        });

        // contacts form
        $('.js-form-contacts').on('submit', function() {
            let form = $(this);
            let submBtn = form.find('[type="submit"]');
            submBtn.addClass('disabled');

            if (formValid(form)) {
                form.find('input').val('');
                form.find('textarea').val('');
                form.next('.contactform-success-container').fadeIn(50);
            }
            else {
                submBtn.removeClass('disabled');
            }
            return false;
        });

        // faqs
        $('.js-faqBtn').on('click', function() {
            $(this).toggleClass('opened');
            $(this).next().slideToggle();
        });

        // device slider
        $('.js-slider-device').slick({
            infinite: true,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $('.js-slider-device-arrowPrev'),
            nextArrow: $('.js-slider-device-arrowNext'),
            asNavFor: '.js-slider-deviceNav',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        dots: true
                    }
                },
            ]
        });

        $('.js-slider-deviceNav').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.js-slider-device',
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: $('.js-slider-deviceNav-arrowPrev'),
            nextArrow: $('.js-slider-deviceNav-arrowNext'),
        });

        // plans slider
        let slideCount = $('.js-slider-plans').data('count');
        $('.js-slider-plans').slick({
            initialSlide: slideCount-4,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: $('.js-slider-plans-arrowPrev'),
            nextArrow: $('.js-slider-plans-arrowNext'),
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        initialSlide: slideCount-3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        initialSlide: slideCount-2,
                        slidesToShow: 1,
                        variableWidth: true,
                        arrows: false
                    }
                }
            ]
        });
        
function getQtyForCheckbox($checkbox) {
            const $titleBlock = $checkbox.closest('.plans-item-kiosk-tabs-content-item-title');
            
            if ($titleBlock.length) {
                const $quant = $titleBlock.next('.plans-item-kiosk-tabs-content-item-quant');
                if ($quant.length) {
                    const val = Number($quant.find('input[type="number"]').val() || 1);
                    return val > 0 ? val : 1;
                }
            }

            const $inside = $checkbox.closest('[data-kiosk-tabs]').find('input[type="number"]');
            if ($inside.length) return Number($inside.first().val() || 1);

            return 1;
        }
        
        function recalcPlanTotal(plan) {
            let basePriceContainer = plan.find('.js-planTabsPrice');
            let textContainer = plan.find('.js-planTabsText');
            let basePrice = Number(basePriceContainer.data('price')) || 0;
            let total = basePrice;

            plan.find('.js-tabsKiosk-checkbox:checked').each(function() {
                let price = Number($(this).data('price')) || 0;
                let qty = getQtyForCheckbox($(this));
                total += price * qty;
            });

            if (total > 0) {
                if (textContainer.length) textContainer.hide();
                
                basePriceContainer.show().text((Math.round(total * 100) / 100).toFixed(2));
                
                plan.find('.plans-item-price span').show();
            } else {
                if (textContainer.length) textContainer.show();
                basePriceContainer.hide();
                
                plan.find('.plans-item-price span').hide();
            }
        }
        
        $('.js-toggle-kiosk').on('change', function(){
            const block = $(this).closest('.plans-item-kiosk');
            const plan  = $(this).closest('.plans-item');

            if ($(this).is(':checked')) {
                block.find('.js-toggle-kiosk-content').show();
            } else {
                block.find('.js-toggle-kiosk-content').hide();
                
                block.find('.js-tabsKiosk-btn').removeClass('active');
                block.find('.js-tabsKiosk-btn').first().addClass('active');

                block.find('.plans-item-kiosk-tabs-content-item').addClass('hidden');
                block.find('.plans-item-kiosk-tabs-content-item').first().removeClass('hidden');
                
                block.find('.js-tabsKiosk-checkbox').prop('checked', false);
                block.find('input[type="number"]').val(1);
                
                recalcPlanTotal(plan);
            }
        });

        // Initialize kiosk tabs
        $('.js-tabsKiosk').each(function() {
            const $container = $(this);
            const $buttons = $container.find('.js-tabsKiosk-btn');
            
            $buttons.on('click', function(e) {
                e.preventDefault();
                const $button = $(this);
                
                if (!$button.hasClass('active')) {
                    $buttons.removeClass('active');
                    $button.addClass('active');
                    
                    const tabId = $button.data('kiosk-target');
                    const $contentItems = $container.closest('.js-toggle-kiosk-content').find('[data-kiosk-tabs]');
                    
                    $contentItems.addClass('hidden');
                    $contentItems.filter('[data-kiosk-tabs="' + tabId + '"]').removeClass('hidden');
                }
            });
        });
        
        $(document).on('change', '.js-tabsKiosk-checkbox', function() {
            const plan = $(this).closest('.plans-item');
            recalcPlanTotal(plan);
        });
            
        $('.plans-item').each(function() {
            recalcPlanTotal($(this));
        });

        // open product modal
        $('.js-openProductModal').click(function(){

            let productId = $(this).data('id');

            let data = {
                'action': 'get_product_info',
                'postid' : productId
            };
            
            $.arcticmodal({
                type: 'ajax',
                url: '/wp-admin/admin-ajax.php',
                ajax: {
                    data : data,
                    type : 'POST',
                    cache: false,
                    dataType: 'json',
                    success: function( data, el, responce ) {
                        var h = $('<div class="modal modal-full">' +
                                    '<div class="modal-close arcticmodal-close"></div>' +                                
                                    '<div class="modal-inner">' +
                                        '<div class="modal-header"><div class="modal-title"></div></div>' +
                                        '<div class="modal-content"><div class="devices-article-content">' +
                                            '<div class="devices-article-left"><div class="devices-article-left-text"></div></div>' +
                                            '<div class="devices-article-right"></div>' +
                                        '</div></div>' +
                                    '</div>' +
                                '</div>');
                        $('.modal-title', h).html(responce.title);
                        $('.devices-article-left-text', h).html(responce.content);
                        $('.devices-article-right', h).html('<img src="'+responce.image+'" alt="">');
                        data.body.html(h);
                    }
                }
            });

        });

        //
        function delay(callback, ms) {
            var timer = 0;
            return function() {
                var context = this, args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                callback.apply(context, args);
                }, ms || 0);
            };
        }

        function searchAndSort() {
            $().setGetParams({
                'search': $('.js-partnerSearch').val().length != 0 ? $('.js-partnerSearch').val() : '',
                'sort': $('.js-partnerSort').val(),
                'paged': 1
            });
        }

        $('.js-partnerSearch').keyup(delay(function (e) {
            searchAndSort();
        }, 500));

        $('.js-partnerSort').on('change', function(){
            searchAndSort();
        });

        // Tooltip functionality
        $('.plans-item-content-list-tooltip').each(function() {
            const $tooltip = $(this);
            const tooltipText = $tooltip.attr('data-descr');
            
            if (tooltipText) {
                // Create tooltip element
                const $tooltipElement = $('<div class="plans-item-content-list-tooltip-content">' + tooltipText + '</div>');
                $('body').append($tooltipElement);
                
                // Position tooltip on hover
                $tooltip.on('mouseenter', function(e) {
                    const tooltipWidth = $tooltipElement.outerWidth();
                    const tooltipHeight = $tooltipElement.outerHeight();
                    const iconWidth = $tooltip.outerWidth();
                    const iconHeight = $tooltip.outerHeight();
                    const iconOffset = $tooltip.offset();
                    
                    let left = iconOffset.left + (iconWidth / 2) - (tooltipWidth / 2);
                    let top = iconOffset.top - tooltipHeight - 8;
                    
                    // Adjust position if tooltip goes out of viewport
                    if (left < 10) {
                        left = 10;
                    }
                    if (left + tooltipWidth > $(window).width() - 10) {
                        left = $(window).width() - tooltipWidth - 10;
                    }
                    if (top < 10) {
                        top = iconOffset.top + iconHeight + 8;
                    }
                    
                    $tooltipElement.css({
                        'left': left + 'px',
                        'top': top + 'px',
                        'opacity': '1',
                        'visibility': 'visible'
                    });
                });
                
                // Hide tooltip on mouse leave
                $tooltip.on('mouseleave', function() {
                    $tooltipElement.css({
                        'opacity': '0',
                        'visibility': 'hidden'
                    });
                });
                
                // Hide tooltip on touch devices
                $tooltip.on('touchstart', function() {
                    $tooltipElement.css({
                        'opacity': '0',
                        'visibility': 'hidden'
                    });
                });
            }
        });

    });

})(jQuery);